import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import Input from "../input";
import Button from "../button";
import { Form, Formik, FormikContextType } from "formik";
import { createRef, useEffect } from "react";
import { createVoucherActiveValidationSchema } from "@app/validations";
import { FormControl } from "../form-control";
import { CreateVoucherActiveForm, VoucherActive } from "@app/types";
import { formatDate } from "@app/utils/util";
import { DATE_TIME_FORMAT_2 } from "@app/constants";

interface VoucherActiveModalProps {
  isEdit: boolean;

  voucherActive: VoucherActive;
}

function VoucherActiveModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<VoucherActiveModalProps>) {
  const formRef = createRef<FormikContextType<CreateVoucherActiveForm>>();

  const onSubmit = (values: CreateVoucherActiveForm) => {
    portalDialogRef.close({ voucherActive: values });
  };

  useEffect(() => {
    if (portalData?.voucherActive && formRef.current) {
      formRef.current.setValues({
        code: portalData.voucherActive.code,
        name: portalData.voucherActive.name,
        expiredTime: formatDate(
          portalData.voucherActive.expiredTime * 1000,
          DATE_TIME_FORMAT_2
        ),
        totalUse: String(portalData.voucherActive.totalUse),
      });
    }
  }, [portalData?.voucherActive]);

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[423px] py-7 px-6">
        <div className="text-black font-semibold text-xl">
          {portalData?.isEdit ? "Chỉnh sửa" : "Thêm voucher active"}
        </div>
        <Formik
          initialValues={{ code: "", name: "", expiredTime: "", totalUse: "" }}
          onSubmit={onSubmit}
          innerRef={formRef}
          validationSchema={createVoucherActiveValidationSchema}
          validateOnChange
          validateOnBlur
        >
          <Form>
            <FormControl name="code">
              <Input
                inputClassName="text-[#2C2D33]"
                className="mt-7"
                placeholder="Mã"
              />
            </FormControl>
            <FormControl name="name">
              <Input
                inputClassName="text-[#2C2D33]"
                className="mt-7"
                placeholder="Tên"
              />
            </FormControl>
            <FormControl name="expiredTime">
              <Input
                inputClassName="text-[#2C2D33]"
                className="mt-7"
                placeholder="Tên"
                type="datetime-local"
              />
            </FormControl>
            <FormControl name="totalUse">
              <Input
                inputClassName="text-[#2C2D33]"
                className="mt-7"
                placeholder="Số người dùng tối đa"
              />
            </FormControl>
            <div className="mt-11 flex justify-center gap-4">
              <Button
                size="xs"
                label="Hủy"
                theme="secondary"
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
                onClick={portalDialogRef.close}
              />
              <Button
                type="submit"
                size="xs"
                label={portalData?.isEdit ? "Lưu" : "Thêm"}
                width={180}
                className="!h-[51px] !leading-[51px]"
                labelClassName="text-xl"
              />
            </div>
          </Form>
        </Formik>
      </div>
    </Modal>
  );
}

export default VoucherActiveModal;
